export default __webpack_public_path__ + "d072c425c494ae949cda9d7b7f9b9f45.png";